import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import ShowMoreText from 'react-show-more-text';
import { useT } from '@progress-fe/core';
import s from './ShowMore.module.css';
const ShowMoreFC = ({ lines = 3, children }) => {
    const { t } = useT();
    return (_jsx(ShowMoreText, { lines: lines, expanded: false, more: t('actions.showMore'), less: t('actions.showLess'), truncatedEndingComponent: '... ', anchorClass: s.anchor, children: children }));
};
export const ShowMore = memo(ShowMoreFC);
//# sourceMappingURL=ShowMore.js.map